import { Typography, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { InspirationSection } from "web_myplann/Inspiration/Components/InspirationSection";
import { Callout } from "web_myplann/Shared/Components/Callout";

type Props = {
	title: string;
	description: string;
	icon: LucideIcon;
	nudgeTitle: string;
	nudgeText: string;
	onOpen: () => void;
};

export const InspirationNudgeSection: FC<Props> = ({
	title,
	description,
	icon,
	nudgeTitle,
	nudgeText,
	onOpen,
}) => {
	const theme = useTheme();

	return (
		<InspirationSection title={title} gap={theme.spacingTokens.md}>
			<Typography variant="body2" relaxed>
				{description}
			</Typography>
			<Callout
				color="blue"
				icon={icon}
				title={nudgeTitle}
				description={nudgeText}
				onClick={onOpen}
			/>
		</InspirationSection>
	);
};
